import { useMemo } from 'react';

export interface UsePaginatedRowsProperties<T> {
  paginationValue: number;
  rowsPerPage: number;
  sortedRows?: T[];
}

const usePaginatedRows = <T>({ paginationValue, rowsPerPage, sortedRows }: UsePaginatedRowsProperties<T>): T[] => {
  const paginatedRows = useMemo(() => {
    const start = (paginationValue - 1) * rowsPerPage;
    const end = start + rowsPerPage;
    return sortedRows?.slice(start, end) ?? [];
  }, [paginationValue, rowsPerPage, sortedRows]);

  return paginatedRows;
};

export default usePaginatedRows;
